import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Box, Grid, Button } from '@mui/material';
import { Selection, TextInput, FileUpload, ComboBox, FileUploadContract } from 'components';
import ApiServices from 'services';
import Utils from 'commons/utils';
import { styled } from '@mui/material/styles';
import { QUOTE_PRICE_STATUS_OPTIONS } from 'commons/constants';

const CreateForm = ({ selected, reloadData, onCloseModal, clientCareHistoryItem }) => {
  // init
  const [customerList, setCustomerList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  //
  const [code, setCoCode] = useState('');

  const [quotationDate, setQuotationDate] = useState('');
  const [customerResponseDate, setCustomerResponseDate] = useState('');
  const [status, setStatus] = useState('0');

  const [note, setNote] = useState('');
  //
  const [file, setFile] = useState([]);
  const [currentFile, setCurrentFile] = useState([]);
  const [fileDeleteFromCurrent, setFileDeleteFromCurrent] = useState([]);

  const [serviceIds, setServiceIds] = useState([]);

  const isSubmitting = useMemo(() => {
    return (
      !code ||
      !clientCareHistoryItem?.objClientCompany?.id ||
      !quotationDate ||
      !serviceIds ||
      !serviceIds?.length > 0
    );
  }, [code, clientCareHistoryItem, quotationDate, serviceIds]);

  useEffect(() => {
    // Service
    if (selected?.arrServiceId && serviceList?.length > 0) {
      const findService = serviceList?.filter((el) => selected?.arrServiceId.includes(el.id));
      if (findService?.length > 0) {
        setServiceIds(findService || []);
      }
    }
  }, [customerList, selected, serviceList]);

  useEffect(() => {
    const currentQuotationDate = selected?.quotationDate;
    const currentCustomerResponseDate = selected?.customerResponseDate;
    const currentArrUrlfile = selected?.arrUrlfile;

    if (selected?.code) {
      setCoCode(selected?.code);
    }
    if (currentQuotationDate && Utils.checkIsDate(currentQuotationDate)) {
      setQuotationDate(Utils.convertToDateFormat(currentQuotationDate));
    }
    if (currentCustomerResponseDate && Utils.checkIsDate(currentCustomerResponseDate)) {
      setCustomerResponseDate(Utils.convertToDateFormat(currentCustomerResponseDate));
    }
    if (selected?.status) {
      setStatus(selected?.status);
    }
    if (selected?.note) {
      setNote(selected?.note);
    }
    if (currentArrUrlfile?.length > 0) {
      setCurrentFile(currentArrUrlfile || []);
    }
    setFile([]);
  }, [selected]);

  const getClientCustomer = async () => {
    try {
      const res = await ApiServices.getClientCompanies();
      if (res?.data) {
        setCustomerList(res?.data || []);
      }
    } catch (error) {
      console.log('getClientCompanies Failed:::', error);
    }
  };

  const getClientService = async () => {
    try {
      const res = await ApiServices.getServices();
      if (res?.data) {
        const serviceMain = res?.data?.filter((service) => !service?.parentServiceId);
        setServiceList(serviceMain || []);
      }
    } catch (error) {
      console.log('getServices Failed:::', error);
    }
  };

  useEffect(() => {
    getClientCustomer();
    getClientService();
  }, []);

  const handleClose = () => {
    onCloseModal();
  };

  const handleCreate = async () => {
    const fileTmp = file?.map(([item]) => item);
    const arrServiceIds = serviceIds?.map((item) => item?.id);
    const dataSend = {
      code,
      note,
      arrServiceId: arrServiceIds,
      // arrService: serviceIds,
      iFileAdd: fileTmp,
      clientCompanyId: clientCareHistoryItem?.objClientCompany?.id,
      clientCompanyName: clientCareHistoryItem?.objClientCompany?.name,
      quotationDate,
      customerResponseDate,
      status: +status,
      isActive: true,
    };

    try {
      const res = await ApiServices.createClientQuotation(dataSend);
      if (res?.status === 200) {
        window.UIMessage?.success('Thêm mới thành công');
        handleClose();
        reloadData();
      }
    } catch (error) {
      window.UIMessage?.error('Thêm mới thất bại !!!');
      console.log('Create Contract Failed:::', error);
    }
  };

  const handleUpdate = async () => {
    const quoteId = selected?.id;

    const fileTmp = file?.map(([item]) => item);

    const arrServiceIds = serviceIds?.map((item) => item?.id);
    const dataSend = {
      code,
      note,
      arrServiceId: arrServiceIds,
      iFileAdd: fileTmp,
      iFileRemove: fileDeleteFromCurrent || [],
      clientCompanyId: clientCareHistoryItem?.objClientCompany?.id,
      clientCompanyName: clientCareHistoryItem?.objClientCompany?.name,
      quotationDate,
      customerResponseDate,
      status: +status,
      arrUrlfile: currentFile || [],
    };

    if (!quoteId || !dataSend) return;

    try {
      const res = await ApiServices.updateQuotePrice(quoteId, dataSend);
      if (res?.status === 200) {
        window.UIMessage?.success('Cập nhật thành công');

        handleClose();
        reloadData();
      }
    } catch (error) {
      window.UIMessage?.error('Cập nhật thất bại !!!');
      console.log('Create Contract Failed:::', error);
    }
  };

  const handleSubmit = async () => {
    if (selected.isNew) {
      await handleCreate();
    } else {
      await handleUpdate();
    }
  };

  const handleChangeCode = useCallback(
    (e) => {
      setCoCode(e.target.value);
    },
    [code],
  );

  const handleChangeService = useCallback(
    (_, newValue) => {
      setServiceIds(newValue || []);
    },
    [serviceIds],
  );

  const handleChangeCustomerResponseDate = useCallback(
    (e) => {
      setCustomerResponseDate(e.target.value);
    },
    [customerResponseDate],
  );
  const handleChangeQuotationDate = useCallback(
    (e) => {
      setQuotationDate(e.target.value);
    },
    [quotationDate],
  );

  const handleChangeStatus = useCallback(
    (e) => {
      setStatus(e.target.value);
    },
    [status],
  );
  const handleChangeNote = useCallback(
    (e) => {
      setNote(e.target.value);
    },
    [note],
  );
  const handleChangeFile = useCallback(
    (e) => {
      setFile(e.target.value);
    },
    [file],
  );
  const handleChangeCurrentFile = useCallback(
    (fileCurrent, fileDelete) => {
      setCurrentFile(fileCurrent || []);
      setFileDeleteFromCurrent((prev) => {
        return [...prev, fileDelete];
      });
    },
    [currentFile],
  );
  return (
    <Box>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={6}>
          <TextInput
            required
            error={!code}
            helperText={!code && 'Vui lòng nhập mã báo giá'}
            label="Mã báo giá"
            name="code"
            onChange={handleChangeCode}
            value={code}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <TextInput
            label="Khách hàng"
            name="code"
            value={clientCareHistoryItem?.objClientCompany?.name || ''}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <TextInput
            required
            error={!quotationDate}
            helperText={!quotationDate && 'Vui lòng nhập ngày báo giá'}
            label="Ngày báo giá"
            name="quotationDate"
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChangeQuotationDate}
            value={quotationDate}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <ComboBox
            error={!serviceIds?.length > 0}
            helperText={!serviceIds?.length > 0 && 'Vui lòng chọn dịch vụ'}
            multiple
            disableCloseOnSelect
            options={serviceList}
            label="Dịch vụ"
            sx={{ width: '100%', marginTop: '8px' }}
            keyField="name"
            value={serviceIds}
            onChange={handleChangeService}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <TextInput
            label="Ngày KH phản hồi"
            name="customerResponseDate"
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChangeCustomerResponseDate}
            value={customerResponseDate}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Selection
            displayNone={false}
            label="Trạng thái"
            name="status"
            onChange={handleChangeStatus}
            value={status}
            dataArrObject={QUOTE_PRICE_STATUS_OPTIONS}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <FileUploadContract
            // error={Boolean(touched.file && errors.file)}
            // helperText={touched.file && errors.file}
            label="File đính kèm"
            name="file"
            // onBlur={handleBlur}
            onChange={handleChangeFile}
            value={file}
            multiple={true}
            isUploadOnlyContract={true}
            valueCurrent={currentFile}
            onChangeCurrent={handleChangeCurrentFile}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <TextInput
            label="Ghi chú"
            name="summaryNote"
            onChange={handleChangeNote}
            value={note}
            multiline={true}
            rows={2}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', py: 2 }}>
        <Box sx={{ marginLeft: 'auto' }}>
          <BtnCreateUpdate
            color="primary"
            disabled={isSubmitting}
            onClick={handleSubmit}
            variant="contained"
          >
            {selected?.isNew ? 'Thêm mới' : 'Cập nhật'}
          </BtnCreateUpdate>
        </Box>
      </Box>
    </Box>
  );
};

export { CreateForm };

export const BtnCreateUpdate = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '5px',
  margin: '0px 5px',
  border: '1px solid rgba(0, 0, 0, 0.4)',
  padding: '6px 25px',
  '.MuiButton-startIcon': {
    marginRight: '10px',
  },
}));
